const QueryServices = {
  userQuery: {
    url: "/query",
    method: "POST",
  },
  userContactUs: {
    url: "/contact-us",
    method: "POST",
  },
};
export default QueryServices;
